<div class="accordian">
  <!-- Start Accordian Header -->
  <div *ngIf="!hasCustomHeader" (click)="toggleIsExpanded()" class="flex-between-center accordian-header pointer">
    <div class="mb-0 flex-start-header pointer">
      <div class="flex-start-center custom-header-wrapper flex-row position-relative">

        <!-- Drag handler -->
        <div class="drag-trigger-header" *ngIf="isDragable" (mousedown)="dragItem()">
          <i class="fas fa-grip-vertical grip-font font-16"></i>
        </div>

        <i class="pr-3 pl-3 fal"
          [ngClass]="{'fa-chevron-down': isExpanded, 'fa-chevron-right': !isExpanded, 'font-14': iconSize === 14, 'font-12': iconSize === 12, 'font-10': iconSize === 10}"></i>
        <span class="custom-checkbox">
          <p-checkbox *ngIf="hasHeaderCheckbox && itemCheckboxPositiion === 'start'" name=""
            styleClass='field-checkbox font-12' value="true" label="" (onChange)="handleHeaderCheckItem()" binary="true"
            checkboxIcon="fal fa-check">
          </p-checkbox>
        </span>
        <div class="accordian-header-label"
          [ngClass]="{'font-14': fontSize === 14, 'font-12': fontSize === 12, 'font-10': fontSize === 10}">
          {{ renderHeaderTitle() }}
        </div>
      </div>
    </div>

    <div class="flex-end-center">
      <span [hidden]="!hasDeleteOption" class="mr-4">
        <i (click)="handleGroupDelete()" class="fal fa-trash delete-icon pointer"></i>
      </span>
      <span [hidden]="!showSelectedItem">
        <span [hidden]="hasCustomSelectedItemText" class="font-10">
          {{ selectedItems.length }} <span [hidden]="!isExpanded">selected</span>
        </span>
        <span [hidden]="!hasCustomSelectedItemText" class="font-10">
          {{ renderSelectedItemLabel() }}
        </span>
      </span>
      <span>
        <i *ngIf="selectedItems.length > 0 && selectedItems.length === items.length"
          class="checkbox-icon pointer ml-2 font-15 fas fa-check-square"
          (click)="handleHeaderCheckItem('deselect', $event); false"></i>
        <i *ngIf="selectedItems.length === 0" class="checkbox-icon pointer ml-2 font-15 far fa-stop"
          (click)="handleHeaderCheckItem('select', $event); false"></i>
        <i *ngIf="selectedItems.length > 0 &&  selectedItems.length !== items.length"
          class="checkbox-icon pointer ml-2 font-15 fas fa-minus-square"
          (click)="handleHeaderCheckItem('select', $event); false"></i>
      </span>
    </div>

  </div>
  <!-- End Accordian Header -->

  <!-- Start Custom Accordian Header -->
  <div *ngIf="hasCustomHeader" (click)="toggleIsExpanded()"
    class="flex-between-center accordian-header pointer custom-accordian-header" [ngClass]="{'transparent-bg': customHeaderTransparentBg}">
    <div class="custom-accordian-header-wrapper flex-start-center">
      <div class="custom-accordian-header-checkbox display-start-center">
        <i class="pr-2 fal"
          [ngClass]="{'fa-chevron-down': isExpanded, 'fa-chevron-right': !isExpanded, 'font-14': iconSize === 14, 'font-12': iconSize === 12, 'font-10': iconSize === 10}"></i>
        <span *ngIf="hasHeaderCheckbox">
          <i *ngIf="items.length !== 0 && selectedItems.length === items.length"
            class="checkbox-icon pointer ml-2 font-15 fas fa-check-square"
            (click)="handleHeaderCheckItem('deselect', $event); false"></i>
          <i *ngIf="selectedItems.length === 0" class="checkbox-icon pointer ml-2 font-15 far fa-stop"
            (click)="handleHeaderCheckItem('select', $event); false"></i>
          <i *ngIf="selectedItems.length > 0 &&  selectedItems.length !== items.length"
            class="checkbox-icon pointer ml-2 font-15 fas fa-minus-square"
            (click)="handleHeaderCheckItem('select', $event); false"></i>
        </span>
      </div>
      <div class="custom-header-template">
        <ng-container
          *ngTemplateOutlet="accordianHeaderTemplate; context: {$implicit: data, selectAll: handleHeaderCheckItem, toggleAccordian: toggleAccordian}">
        </ng-container>
      </div>
    </div>
  </div>
  <!-- End Custom Accordian Header -->

  <!-- Start Accordian Body Draggble -->
  <div *ngIf="isDragable">
    <div [hidden]="!isExpanded">
      <ul *ngIf="!hasCustomTemplate" class="pl-0 accordian-list-drag mb-0" cdkDropList
        (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="disableDragging">

        <li *ngFor="let item of items; let i = index" class="flex-between-center accordian-list-drag-item pointer"
          cdkDragBoundary=".accordian" cdkDrag>

          <!-- Start Default List Item -->
          <div *ngIf="!hasAccordianSubItem" class="custom-checkbox">
            <!-- Drag handler 2 -->
            <div class="drag-trigger-body" (mousedown)="disableDragging = false;" *ngIf="isDragable">
              <i class="fas fa-grip-vertical grip-font font-16"></i>
            </div>

            <p-checkbox *ngIf="hasItemCheckbox && itemCheckboxPositiion === 'start'" [inputId]="item[listItemIdKey]"
              [(ngModel)]="item.isChecked" styleClass="field-checkbox font-12" value="true" label="" binary="true"
              (onChange)="handleCheckItem($event?.checked , item, i)" checkboxIcon="fal fa-check">
            </p-checkbox>

            <span class="ml-3"
              [ngClass]="{'font-14': fontSize === 14, 'font-12': fontSize === 12, 'font-10': fontSize === 10}">
              <label [for]="item[listItemIdKey]" class="pointer m-0 p-1">{{renderFirstLevelItemTitle(item)}}</label>
            </span>
          </div>
          <span *ngIf="!hasAccordianSubItem" class="custom-checkbox">
            <p-checkbox *ngIf="hasItemCheckbox && itemCheckboxPositiion === 'end'" [inputId]="item[listItemIdKey]"
              [(ngModel)]="item.isChecked" styleClass="field-checkbox font-12" value="true" label="" binary="true"
              (onChange)="handleCheckItem($event?.checked, item, i)" checkboxIcon="fal fa-check">
            </p-checkbox>
          </span>
          <!-- End Default List Item -->

          <div class="custom-sub-item flex-start-center" *ngIf="hasAccordianSubItem">
            <span *ngIf="item?.type && showType" class="custom-sub-item-icon">
              <i *ngIf="item?.type === 'part' || item?.type === 'parts'" class="far fa-tools"></i>
              <i *ngIf="item?.type === 'labor'" class="border-left-bottom"></i>
              <i *ngIf="item?.type === 'tire'" class="far fa-tire"></i>
              <i *ngIf="item?.type === 'other' || item?.type === 'fluids' || item?.type === 'sublet'" class="far fa-list-alt"></i>
            </span>
            <div class="custom-sub-item-checkbox flex-center-center" *ngIf="hasAccordianSubItemCheckbox">
              <div class="custom-checkbox">
                <p-checkbox inputId="{{item[listItemIdKey]}}{{data[dataIdKey]}}" name="cb-{{id}}{{index}}-{{i}}"
                  [(ngModel)]="item.isChecked" [value]="item.isChecked" styleClass="field-checkbox font-12" value="true"
                  label="" binary="true" (onChange)="handleCheckItem($event?.checked, item, i)"
                  checkboxIcon="fal fa-check">
                </p-checkbox>
              </div>
            </div>
            <div class="custom-sub-item-content">
              <ng-container
                *ngTemplateOutlet="accordianSubItemTemplate; context: {$implicit: item, index: i, checkboxId: item[listItemIdKey] + data[dataIdKey]}">
              </ng-container>
            </div>
          </div>
        </li>

        <li class="flex-between-center accordian-list-item pointer" *ngIf="hasAccordianSubItemInspection">
          <i class="far fa-ballot-check custom-sub-item-icon"></i>
          <div class="custom-sub-item flex-start-center">
            <div class="custom-sub-item-checkbox flex-center-center">
              <div class="custom-checkbox">
                <p-checkbox [inputId]="data[dataIdKey]" styleClass="field-checkbox font-12" [value]="true" label=""
                  binary="true" checkboxIcon="fal fa-check" [(ngModel)]="inspectionChecked"
                  (onChange)="handleInspectionCheckItem($event?.checked)">
                </p-checkbox>
              </div>
            </div>
            <div class="custom-sub-item-content">
              <ng-container
                *ngTemplateOutlet="accordianSubItemInspectionsTemplate; context: {checkboxId: data[dataIdKey]}">
              </ng-container>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>


  <!-- Start Accordian Body -->
  <div *ngIf="!isDragable">
    <div [hidden]="!isExpanded">
      <ul *ngIf="!hasCustomTemplate" class="pl-0 accordian-list mb-0">
        <li *ngFor="let item of items; let i = index" class="flex-between-center accordian-list-item pointer">
          <!-- Start Default List Item -->
          <div *ngIf="!hasAccordianSubItem" class="custom-checkbox">
            <p-checkbox [inputId]="item[listItemIdKey]" [(ngModel)]="item.isChecked"
              *ngIf="hasItemCheckbox && itemCheckboxPositiion === 'start'" styleClass="field-checkbox font-12"
              value="true" label="" binary="true" (onChange)="handleCheckItem($event?.checked, item, i)"
              checkboxIcon="fal fa-check">
            </p-checkbox>
            <span [ngClass]="{'font-14': fontSize === 14, 'font-12': fontSize === 12, 'font-10': fontSize === 10}">
              <label [for]="item[listItemIdKey]" class="pointer m-0 p-1">{{renderFirstLevelItemTitle(item)}}</label>
            </span>
          </div>
          <span *ngIf="!hasAccordianSubItem" class="custom-checkbox">
            <p-checkbox *ngIf="hasItemCheckbox && itemCheckboxPositiion === 'end'" [inputId]="item[listItemIdKey]"
              [(ngModel)]="item.isChecked" styleClass="field-checkbox font-12" value="true" label="" binary="true"
              (onChange)="handleCheckItem($event?.checked, item, i)" checkboxIcon="fal fa-check">
            </p-checkbox>
          </span>
          <!-- End Default List Item -->

          <div [ngClass]="hasItemSubItem ? 'custom-sub-item': 'custom-sub-item flex-start-center'"
            *ngIf="hasAccordianSubItem">
            <span *ngIf="item?.type && showType && isMotorServiceEnhanced"
              [ngClass]="hasItemSubItem ? 'custom-sub-item-icon mr-3 pt-10 ui-g-1': 'custom-sub-item-icon'">
              <i *ngIf="item?.type === 'part' || item?.type === 'parts'" class="border-left-bottom"></i>
              <i *ngIf="item?.type === 'labor'" class="border-left-bottom"></i>
              <i *ngIf="item?.type === 'tire'" class="border-left-bottom"></i>
              <i *ngIf="item?.type === 'other' || item?.type === 'fluids' || item?.type === 'sublet'" class="border-left-bottom"></i>
              <i *ngIf="item?.type === 'bundle'" class="border-left-bottom"></i>
            </span>

            <span *ngIf="item?.type && showType && !isMotorServiceEnhanced"
              [ngClass]="hasItemSubItem ? 'custom-sub-item-icon mr-3 pt-10 ui-g-1': 'custom-sub-item-icon'">
              <i *ngIf="item?.type === 'part' || item?.type === 'parts'" class="far fa-tools"></i>
              <i *ngIf="item?.type === 'labor'" class="far fa-user-hard-hat"></i>
              <i *ngIf="item?.type === 'tire'" class="far fa-tire"></i>
              <i *ngIf="item?.type === 'other' || item?.type === 'fluids' || item?.type === 'sublet'" class="far fa-list-alt"></i>
              <i *ngIf="item?.type === 'bundle'" class="fa-box fas"></i>
            </span>

            <div *ngIf="hasAccordianSubItemCheckbox"
              [ngClass]="!hasItemSubItem ? 'custom-sub-item-checkbox flex-center-center': ''">
              <div [ngClass]="hasItemSubItem ? ' custom-checkbox ui-g-1 width2p': 'custom-checkbox'">
                <p-checkbox inputId="{{item[listItemIdKey]}}{{data[dataIdKey]}}" name="cb-{{id}}{{index}}-{{i}}"
                  [(ngModel)]="item.isChecked" [value]="item.isChecked" styleClass="field-checkbox font-12" value="true"
                  label="" binary="true" (onChange)="handleCheckItem($event?.checked, item, i)"
                  [checkboxIcon]="item.checkboxIcon ? item.checkboxIcon : checkboxIcon">
                </p-checkbox>
              </div>
            </div>
            <div class="custom-sub-item-content">
              <ng-container
                *ngTemplateOutlet="accordianSubItemTemplate; context: {$implicit: item, index: i, checkboxId: item[listItemIdKey] + data[dataIdKey]}">
              </ng-container>
            </div>
          </div>
        </li>

        <li class="flex-between-center accordian-list-item pointer" *ngIf="hasAccordianSubItemInspection">
          <i class="far fa-ballot-check custom-sub-item-icon"></i>
          <div class="custom-sub-item flex-start-center">
            <div class="custom-sub-item-checkbox flex-center-center">
              <div class="custom-checkbox">
                <p-checkbox styleClass="field-checkbox font-12" binary="true" checkboxIcon="fal fa-check"
                  [inputId]="data[dataIdKey]" [value]="true" label="" [(ngModel)]="inspectionChecked" [disabled]="disableInspectionCheckbox"
                  (onChange)="handleInspectionCheckItem($event?.checked)">
                </p-checkbox>
              </div>
            </div>
            <div class="custom-sub-item-content">
              <ng-container
                *ngTemplateOutlet="accordianSubItemInspectionsTemplate; context: {checkboxId: data[dataIdKey]}">
              </ng-container>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>


  <div [hidden]="!isExpanded">
    <ul *ngIf="hasCustomTemplate" class="pl-0 nested-accordian mb-0">
      <li *ngFor="let item of items; let i = index"
        class="flex-between-center accordian-list-item pointer nested-accordian-item">
        <ng-container *ngTemplateOutlet="accordianItemTemplate; context: {$implicit: item, index: i}"></ng-container>
      </li>
    </ul>
  </div>
  <!-- End Accordian Body -->

  <div [hidden]="!isExpanded && accordianFooterTemplate">
    <ng-container *ngTemplateOutlet="accordianFooterTemplate"></ng-container>
  </div>
</div>
